// Redux Action CONSTANTS
import * as actionTypes from "./actionTypes";

// Ajax Methods
import ajaxMethods from "../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../api/ajax-endpoints";

// Helpers
import { formatMifosDate } from "../../helpers/formatMifosDate";
import { appInsights } from "../../config/appInsights";

// All Loans for Disbursments
// (1.) Disbursment Columns - Fields for Disbursement Records - DataTable Columns
export const disbursementColumns = [
  { label: "", field: "check", sort: "asc" },
  { label: "LOAN ID", field: "loan_id", sort: "asc" },
  // // Aggregator Bank Details
  { label: "AGGREGATOR ID", field: "aggregator_id", sort: "asc" },
  { label: "ECOSYSTEM", field: "biz_category", sort: "asc" },
  { label: "EMAIL", field: "biz_email", sort: "asc" },
  { label: "AGGREGATOR NAME", field: "biz_name", sort: "asc" },
  { label: "AGGREGATOR PHONE", field: "biz_phone", sort: "asc" },
  // Borrower Details
  { label: "BALANCE", field: "available_balance", sort: "asc" },
  { label: "DEBT BALANCE", field: "debt_balance", sort: "asc" },
  { label: "FIRST NAME", field: "first_name", sort: "asc" },
  { label: "LAST NAME", field: "last_name", sort: "asc" },
  { label: "PHONE", field: "personal_phone", sort: "asc" },
  { label: "BORROWER_ID", field: "borrower_id", sort: "asc" },
  { label: "RC Number", field: "rc_number", sort: "asc" },
  { label: "COMPANY NAME", field: "company_name", sort: "asc" },
  { label: "BORROWER TYPE", field: "borrower_type_value", sort: "asc" },
  // Loan Details
  { label: "LOAN STATUS", field: "status", sort: "asc" },
  { label: "PRODUCT NAME", field: "product_name", sort: "asc" },
  { label: "LOAN AMOUNT", field: "loan_amount", sort: "asc" },
  { label: "LOAN REPAYMENT", field: "loan_amount_repay", sort: "asc" },
  { label: "LOAN INTEREST", field: "loan_interest", sort: "asc" },
  { label: "LOAN REF", field: "loan_ref", sort: "asc" },
  { label: "REPAYMENT BALANCE", field: "loan_repayment_balance", sort: "asc" },
  { label: "LOAN TENURE", field: "loan_tenure", sort: "asc" },
  { label: "MODIFIED DATE", field: "modified_date", sort: "asc" },
  { label: "CREATED DATE", field: "pub_date", sort: "asc" },
  //debit account details
  { label: "Debited Account Number", field: "debit_account_no", sort: "asc" },
  { label: "Debited Account Name", field: "debit_account_name", sort: "asc" },
  { label: "Debited Bank name", field: "debit_bank_name", sort: "asc" },
  { label: "Debited Bank Code", field: "debit_bank_code", sort: "asc" },
  //credit account details
  {
    label: "CREDITED ACCOUNT NUMBER",
    field: "credit_account_no",
    sort: "asc",
  },
  {
    label: "CREDITED ACCOUNT NAME",
    field: "credit_account_name",
    sort: "asc",
  },
  { label: "CREDITED BANK NAME", field: "credit_bank_name", sort: "asc" },
  { label: "CREDITED BANK CODE", field: "credit_bank_code", sort: "asc" },
  { label: "Trust SCORE", field: "trust_score", sort: "asc" },
  {
    label: "CONSOLIDATED SCORE DECISION",
    field: "disbursement_decision",
    sort: "asc",
  },
  { label: "CRC SCORE", field: "crc_score", sort: "asc" },
  { label: "CRC STATUS", field: "crc_status", sort: "asc" },
  { label: "FIRST CENTRAL SCORE", field: "xds_score", sort: "asc" },
  { label: "FIRST CENTRAL STATUS", field: "xds_status", sort: "asc" },
  { label: "SUPERFLUID SCORE", field: "sf_score", sort: "asc" },
  { label: "SUPERFLUID STATUS", field: "sf_status", sort: "asc" },
  { label: "KYC SCORE", field: "kyc_score", sort: "asc" },
  { label: "KYC DOB", field: "request_dob", sort: "asc" },
  { label: "REQUEST FIRST NAME", field: "request_firstname", sort: "asc" },
  { label: "REQUEST LAST NAME", field: "request_lastname", sort: "asc" },
  { label: "REQUEST PHONE NUMBER", field: "request_phone", sort: "asc" },
  { label: "REQUEST GENDER", field: "request_gender", sort: "asc" },
  { label: "MANAGE", field: "manage" },
];

// (2.) Loans for Disbursement Action
export const getLoansForDisbursement = ({
  startDate,
  endDate,
  page,
  size,
  borrowerName,
  loanId,
  bvn,
  rcNumber,
  aggregatorId,
  loanRef,
}) => {
  return function (dispatch) {
    dispatch({
      type: actionTypes.GET_DISBURSEMENTS_START,
    });
    let queryParams = `Page=${page}&PageSize=${size}`;

    if (startDate && endDate) {
      queryParams = `${queryParams}&from_date=${startDate}&to_date=${endDate}`;
    }
    if (borrowerName) {
      queryParams = `${queryParams}&borrowername=${borrowerName}`;
    }
    if (bvn) {
      queryParams = `${queryParams}&bvn=${bvn}`;
    }
    if (rcNumber) {
      queryParams = `${queryParams}&rcnumber=${rcNumber}`;
    }
    if (aggregatorId) {
      queryParams = `${queryParams}&aggregatorId=${Number(aggregatorId)}`;
    }
    if (loanId) {
      queryParams = `${queryParams}&loanid=${Number(loanId)}`;
    }
    if (loanRef) {
      queryParams = `${queryParams}&loanreference=${loanRef}`;
    }

    let endpoint = ajaxEndpoints.LOANS_FOR_DISBURSEMENT;
    if (queryParams) {
      endpoint = `${endpoint}?${queryParams}`;
    }

    ajaxMethods
      .get(endpoint)
      .then((response) => {
        if (response) {
          dispatch({
            type: actionTypes.GET_DISBURSEMENTS_SUCCESS,
            payload: {
              records: [...response.data],
              disbursementCount: response.totalCount,
              size: response.pageSize,
              pageNumber: response.page,
              totalPage: response.totalPages,
            },
          });
        } else {
          dispatch({
            type: actionTypes.GET_DISBURSEMENTS_FAILURE,
            error: {
              errorMsg: "other error",
            },
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "loans.js",
          },
        });
        dispatch({
          type: actionTypes.GET_DISBURSEMENTS_FAILURE,
          error,
        });
      });
  };
};

export const removeDisbursedLoans = (loans) => {
  return {
    type: actionTypes.REMOVE_DISBURSED_LOANS,
    payload: {
      loans,
    },
  };
};
export const removeDeniedLoans = (loans) => {
  return {
    type: actionTypes.REMOVE_DENIED_LOANS,
    payload: {
      loans,
    },
  };
};
export const setDisbursementFilterStartDate = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_FILTER_START_DATE,
    payload: value,
  };
};
export const setDisbursementFilterEndDate = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_FILTER_END_DATE,
    payload: value,
  };
};
export const setDisbursementPageCount = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_COUNT,
    payload: value,
  };
};
export const setDisbursementPageNumber = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_PAGE_NUMBER,
    payload: value,
  };
};
export const setDisbursementPageSize = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_SIZE,
    payload: value,
  };
};
export const setDisbursementBorrowerName = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_BORROWER_NAME,
    payload: value,
  };
};
export const setDisbursementLoanId = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_LOAN_ID,
    payload: value,
  };
};
export const setDisbursementBvn = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_BVN,
    payload: value,
  };
};
export const setDisbursementRcNumber = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_RC_NUMBER,
    payload: value,
  };
};
export const setDisbursementAggregatorId = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_AGGREGATOR_ID,
    payload: value,
  };
};
export const setDisbursementLoanRef = (value) => {
  return {
    type: actionTypes.SET_DISBURSEMENT_LOAN_REF,
    payload: value,
  };
};
// All Repayments
// (1.) Repayment Columns
export const repaymentColumns = [
  { label: "ID", field: "repayment_id" },
  { label: "REPAYMENT REF", field: "repayment_ref", sort: "asc" },
  { label: "PARTNER NAME", field: "borrower_full_name", sort: "asc" },
  { label: "AGGREGATOR", field: "aggregator_name", sort: "asc" },
  { label: "LOAN REF", field: "loan_ref", sort: "asc" },
  // { label: 'LOAN STATUS', field: 'loan_status', sort: 'asc' },
  { label: "REPAYMENT AMOUNT", field: "repayment_amount", sort: "asc" },
  { label: "REPAYMENT DATE", field: "repayment_date", sort: "asc" },
  { label: "CORE BANKING STATUS", field: "corebanking_status", sort: "asc" },
  {
    label: "REPAYMENT CHANNEL STATUS",
    field: "repayment_channel_status",
    sort: "asc",
  },
  { label: "REPAYMENT STATUS", field: "repayment_status", sort: "asc" },
  { label: "CURRENCY", field: "currency", sort: "asc" },
  // Manage Buttons
  { label: "MANAGE", field: "manage" },
];

// (2.) Repayment Action
export const getAllRepayments = (queryString) => {
  return function (dispatch) {
    dispatch({
      type: actionTypes.GET_REPAYMENTS_START,
    });

    let endpoint = ajaxEndpoints.ALL_REPAYMENTS;
    if (queryString) {
      endpoint = `${endpoint}?${queryString}`;
    }

    ajaxMethods
      .get(endpoint)
      .then((response) => {
        if (response) {
          const reOrderedTableData = reOrderTableData(
            repaymentColumns,
            response.data
          );
          dispatch({
            type: actionTypes.GET_REPAYMENTS_SUCCESS,
            payload: {
              repaymentsTableData: reOrderedTableData,
              records: [...response.data],
              count: response.count,
              next_page: response.next_page,
              prev_page: response.prev_page,
            },
          });
        } else {
          dispatch({
            type: actionTypes.GET_REPAYMENTS_FAILURE,
            error: {
              errorMsg: "other error",
            },
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "loans.js",
          },
        });
        dispatch({
          type: actionTypes.GET_REPAYMENTS_FAILURE,
          error,
        });
      });
  };
};

// All Loans
// (1.) Loans Columns
export const loanColumns = [
  { label: "ID", field: "loan_id", sort: "asc" },
  // Aggregator Details
  { label: "AGGREGATOR ID", field: "aggregator_id", sort: "asc" },
  { label: "ECOSYSTEM", field: "biz_category", sort: "asc" },
  { label: "EMAIL", field: "biz_email", sort: "asc" },
  { label: "AGGREGATOR NAME", field: "biz_name", sort: "asc" },
  { label: "AGGREGATOR PHONE", field: "biz_phone", sort: "asc" },
  // Borrower Details
  { label: "BORROWER ID", field: "borrower_id", sort: "asc" },
  { label: "BALANCE", field: "available_balance", sort: "asc" },
  { label: "DEBT BALANCE", field: "debt_balance", sort: "asc" },
  { label: "FIRST NAME", field: "first_name", sort: "asc" },
  { label: "LAST NAME", field: "last_name", sort: "asc" },
  { label: "PHONE", field: "personal_phone", sort: "asc" },
  { label: "RC Number", field: "rc_number", sort: "asc" },
  { label: "COMPANY NAME", field: "company_name", sort: "asc" },
  { label: "BORROWER TYPE", field: "borrower_type_value", sort: "asc" },
  // Loan Details
  { label: "DISBURSED", field: "has_disburse", sort: "asc" },
  { label: "REPAID", field: "has_repaid", sort: "asc" },
  { label: "ACTIVE", field: "is_active", sort: "asc" },
  { label: "LOAN AMOUNT", field: "loan_amount", sort: "asc" },
  { label: "LOAN REPAID", field: "loan_amount_repay", sort: "asc" },
  { label: "LOAN INTEREST", field: "loan_interest", sort: "asc" },
  { label: "LOAN REF", field: "loan_ref", sort: "asc" },
  { label: "Trust Score", field: "borrower_trust_score", sort: "asc" },
  { label: "REPAYMENT BALANCE", field: "loan_repayment_balance", sort: "asc" },
  { label: "LOAN TENURE", field: "loan_tenure", sort: "asc" },
  { label: "CREATED DATE", field: "pub_date", sort: "asc" },
  { label: "MODIFIED DATE", field: "modified_date", sort: "asc" },
  { label: "Funder Name", field: "funder_name", sort: "asc" },
  { label: "Effective DATE", field: "loan_effective_date", sort: "asc" },
  //loan products
  { label: "PRODUCT NAME", field: "product_name", sort: "asc" },
  { label: "Annual Interest", field: "interest_rate", sort: "asc" },
  { label: "Annual Interest", field: "product_code", sort: "asc" },
  // Okra Details
  { label: "OKRA DETAILS", field: "okra_details", sort: "asc" },
  // Gateway info
  {
    label: "Gateway Reference Number",
    field: "disbursement_gateway_reference_no",
    sort: "asc",
  },
  {
    label: "Gateway Response",
    field: "disbursement_gateway_response",
    sort: "asc",
  },
  { label: "Status ID", field: "disbursement_gateway_status_id", sort: "asc" },
  {
    label: "Disbursement Channel Id",
    field: "disbursement_channel_id",
    sort: "asc",
  },
  {
    label: "Gateway Request",
    field: "disbursement_gateway_request",
    sort: "asc",
  },
  {
    label: "Reference Number",
    field: "disbursement_reference_no",
    sort: "asc",
  },
  {
    label: "Disbursement final",
    field: "disbursement_gateway_final",
    sort: "asc",
  },
  {
    label: "Response Date-Time",
    field: "disbursement_response_date_time",
    sort: "asc",
  },
  {
    label: "Request Date-Time",
    field: "disbursement_request_date_time",
    sort: "asc",
  },
  //retried time
  { label: "Retried times", field: "retried_disbursement", sort: "asc" },

  // Manage Buttons
  { label: "MANAGE", field: "manage" },
];
// mifos repayment column
export const mifosRepaymentColumn = [
  { label: "#", field: "period", sort: "asc" },
  { label: "Days", field: "daysInPeriod", sort: "asc" },
  { label: "Date", field: "dueDate", sort: "asc" },
  { label: "Paid Date", field: "obligationsMetOnDate", sort: "asc" },
  { label: "Principal Due", field: "principalDue", sort: "asc" },
  {
    label: "Balance of Loan",
    field: "principalLoanBalanceOutstanding",
    sort: "asc",
  },
  { label: "Interest", field: "interestDue", sort: "asc" },
  { label: "Fees", field: "feeChargesDue", sort: "asc" },
  { label: "Penalties", field: "penaltyChargesDue", sort: "asc" },
  { label: "Due", field: "totalDueForPeriod", sort: "asc" },
  { label: "Paid", field: "totalPaidForPeriod", sort: "asc" },
  { label: "In advance", field: "totalPaidInAdvanceForPeriod", sort: "asc" },
  { label: "Late", field: "totalPaidLateForPeriod", sort: "asc" },
  { label: "Outstanding", field: "totalOutstandingForPeriod", sort: "asc" },
];

export const setLoanFilterStartDate = (value) => {
  return {
    type: actionTypes.SET_LOAN_FILTER_START_DATE,
    payload: value,
  };
};
export const setLoanFilterEndDate = (value) => {
  return {
    type: actionTypes.SET_LOAN_FILTER_END_DATE,
    payload: value,
  };
};
export const setLoanPageCount = (value) => {
  return {
    type: actionTypes.SET_LOAN_COUNT,
    payload: value,
  };
};
export const setLoanPageNumber = (value) => {
  return {
    type: actionTypes.SET_LOAN_PAGE_NUMBER,
    payload: value,
  };
};
export const setLoanPageSize = (value) => {
  return {
    type: actionTypes.SET_LOAN_SIZE,
    payload: value,
  };
};

export const setLoanDisbursedValue = (value) => {
  return {
    type: actionTypes.SET_LOAN_IS_DISBURSED,
    payload: value,
  };
};
export const setLoanApprovedValue = (value) => {
  return {
    type: actionTypes.SET_LOAN_IS_APPROVED,
    payload: value,
  };
};

export const setLoanStatusValue = (value) => {
  return {
    type: actionTypes.SET_LOAN_STATUS,
    payload: value,
  };
};
export const setLoanStartDateValue = (value) => {
  return {
    type: actionTypes.SET_LOAN_START_DATE,
    payload: value,
  };
};
export const setLoanEndDateValue = (value) => {
  return {
    type: actionTypes.SET_LOAN_END_DATE,
    payload: value,
  };
};
export const setLoanOnMifos = (value) => {
  return {
    type: actionTypes.SET_LOAN_ON_MIFOS,
    payload: value,
  };
};
export const setBorrowerName = (value) => {
  return {
    type: actionTypes.SET_LOAN_BORROWER_NAME,
    payload: value,
  };
};
export const setLoanId = (value) => {
  return {
    type: actionTypes.SET_LOAN_ID,
    payload: value,
  };
};
export const setBvn = (value) => {
  return {
    type: actionTypes.SET_LOAN_BVN,
    payload: value,
  };
};
export const setRcNumber = (value) => {
  return {
    type: actionTypes.SET_LOAN_RC_NUMBER,
    payload: value,
  };
};
export const setAggregatorId = (value) => {
  return {
    type: actionTypes.SET_LOAN_AGGREGATOR_ID,
    payload: value,
  };
};
export const setLoanRef = (value) => {
  return {
    type: actionTypes.SET_LOAN_REFERENCE,
    payload: value,
  };
};
// (2.) Loan Action
export const getAllLoans = ({
  startDate,
  endDate,
  page,
  size,
  disbursed,
  approved,
  status,
  disbursement_from,
  disbursement_to,
  IsMigratedtoCBA,
  borrowerName,
  loanId,
  bvn,
  rcNumber,
  aggregatorId,
  loanRef,
}) => {
  return function (dispatch) {
    dispatch({
      type: actionTypes.GET_LOANS_START,
    });
    let queryParams = `Page=${page}&PageSize=${size}`;

    if (startDate && endDate) {
      queryParams = `${queryParams}&from_date=${startDate}&to_date=${endDate}`;
    }
    if (
      disbursed === "true" ||
      disbursed === true ||
      disbursed === "false" ||
      disbursed === false
    ) {
      // Convert to boolean if it is a string
      queryParams = `${queryParams}&disbursed=${JSON.parse(disbursed)}`;
    }
    if (
      approved === "true" ||
      approved === true ||
      approved === "false" ||
      approved === false
    ) {
      // Convert to boolean if it is a string
      queryParams = `${queryParams}&approved=${JSON.parse(approved)}`;
    }
    if (
      IsMigratedtoCBA === "true" ||
      IsMigratedtoCBA === true ||
      IsMigratedtoCBA === "false" ||
      IsMigratedtoCBA === false
    ) {
      // Convert to boolean if it is a string
      queryParams = `${queryParams}&IsMigratedtoCBA=${JSON.parse(
        IsMigratedtoCBA
      )}`;
    }
    if (status) {
      queryParams = `${queryParams}&status=${status}`;
    }
    if (disbursement_from) {
      queryParams = `${queryParams}&disbursement_from=${disbursement_from}`;
    }
    if (disbursement_to) {
      queryParams = `${queryParams}&disbursement_to=${disbursement_to}`;
    }
    if (borrowerName) {
      queryParams = `${queryParams}&borrowername=${borrowerName}`;
    }
    if (bvn) {
      queryParams = `${queryParams}&bvn=${bvn}`;
    }
    if (rcNumber) {
      queryParams = `${queryParams}&rcnumber=${rcNumber}`;
    }
    if (aggregatorId) {
      queryParams = `${queryParams}&aggregatorId=${Number(aggregatorId)}`;
    }
    if (loanId) {
      queryParams = `${queryParams}&loanid=${Number(loanId)}`;
    }
    if (loanRef) {
      queryParams = `${queryParams}&loanreference=${loanRef}`;
    }

    let endpoint = ajaxEndpoints.ALL_LOANS;
    if (queryParams) {
      endpoint = `${endpoint}?${queryParams}`;
    }
    ajaxMethods
      .get(endpoint)
      .then((response) => {
        if (response) {
          dispatch({
            type: actionTypes.GET_LOANS_SUCCESS,
            payload: {
              records: [...response.data],
              count: response.totalCount,
              size: response.pageSize,
              pageNumber: response.page,
              totalPage: response.totalPages,
            },
          });
        } else {
          dispatch({
            type: actionTypes.GET_LOANS_FAILURE,
            error: {
              errorMsg: "other error",
            },
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "loans.js",
          },
        });
        dispatch({
          type: actionTypes.GET_LOANS_FAILURE,
          error,
        });
      });
  };
};
export const displayRepaymentColumns = [
  { label: "Transfered amount", field: "trans_amount", sort: "asc" },
  { label: "Full Name", field: "borrower_full_name", sort: "asc" },
  { label: "Repayment Ref", field: "repayment_ref", sort: "asc" },
  // { label: "Pub Date", field: "pub_date", sort: "asc" },
  { label: "Oustanding", field: "loan_outstanding", sort: "asc" },
  { label: "Due Date", field: "loan_due_date", sort: "asc" },
];
export const displayLoanScheduleColumns = [
  { label: "Pay Date", field: "pay_date", sort: "asc" },
  { label: "Amount", field: "repay_amount", sort: "asc" },
];

export const pendingRepaymentColumns = [
  // Aggregator Details
  { label: "AGGREGATOR ID", field: "aggregator_id", sort: "asc" },
  { label: "ECOSYSTEM", field: "biz_category", sort: "asc" },
  { label: "EMAIL", field: "biz_email", sort: "asc" },
  { label: "AGGREGATOR NAME", field: "biz_name", sort: "asc" },
  { label: "AGGREGATOR PHONE", field: "biz_phone", sort: "asc" },
  // Borrower Details
  { label: "BORROWER ID", field: "borrower_id", sort: "asc" },
  { label: "BALANCE", field: "available_balance", sort: "asc" },
  { label: "DEBT BALANCE", field: "debt_balance", sort: "asc" },
  { label: "FIRST NAME", field: "first_name", sort: "asc" },
  { label: "LAST NAME", field: "last_name", sort: "asc" },
  { label: "PHONE", field: "personal_phone", sort: "asc" },
  // Loan Details
  { label: "ID", field: "loan_id", sort: "asc" },
  { label: "DISBURSED", field: "has_disburse", sort: "asc" },
  { label: "REPAID", field: "has_repaid", sort: "asc" },
  { label: "STATUS", field: "is_active", sort: "asc" },
  { label: "LOAN REPAID", field: "loan_amount_repay", sort: "asc" },
  { label: "LOAN INTEREST", field: "loan_interest", sort: "asc" },
  { label: "LOAN REF", field: "loan_ref", sort: "asc" },
  { label: "REPAYMENT BALANCE", field: "loan_repayment_balance", sort: "asc" },
  { label: "LOAN TENURE", field: "loan_tenure", sort: "asc" },
  { label: "CREATED DATE", field: "pub_date", sort: "asc" },
  // Other Details
  { label: "REPAID", field: "is_done", sort: "asc" },
  { label: "REPAYMENT ID", field: "repayment_id", sort: "asc" },
  { label: "TRANSACTION AMOUNT", field: "trans_amount", sort: "asc" },
  { label: "TRANSACTION CHARGES", field: "trans_charges", sort: "asc" },
  { label: "TRANSACTION ACTION", field: "tx_action", sort: "asc" },
  { label: "TRANSACTION NOTE", field: "tx_note", sort: "asc" },
  { label: "TRANSACTION REF", field: "tx_ref", sort: "asc" },
  { label: "MODIFIED DATE", field: "modified_date", sort: "asc" },
  // Manage Buttons
  { label: "MANAGE", field: "manage" },
];

//Credit History
//1. Credit History Columns
export const creditHistoryColumns = [
  { label: "XC ID", field: "xc_id", sort: "asc" },
  { label: "SUBSCRIBER NAME", field: "subscriber_name", sort: "asc" },
  {
    label: "OPENING BALANCE AMOUNT",
    field: "opening_balance_amt",
    sort: "asc",
  },
  { label: "PERFORMANCE STATUS", field: "performance_status", sort: "asc" },
  { label: "ACCOUNT STATUS", field: "account_status", sort: "asc" },
  { label: "LOAN DURATION", field: "loan_duration", sort: "asc" },
  { label: "INSTALMENT AMOUNT", field: "instalment_amount", sort: "asc" },
  { label: "DATE ACCOUNT OPENED", field: "date_account_opened", sort: "asc" },
];

//Reconciliation
//1. Reconciliation Columns
export const reconciliationColumns = [
  { label: "BVN", field: "bvn", sort: "asc" },
  { label: "CUSTOMER ID", field: "customerid", sort: "asc" },
  { label: "CUSTOMER NAME", field: "customername", sort: "asc" },
  { label: "DELIVERY DATE", field: "deliverydate", sort: "asc" },
  { label: "FINANCE AMOUNT", field: "finance_amt", sort: "asc" },
  { label: "INTEREST RATE", field: "interest_rate", sort: "asc" },
  { label: "LENDER", field: "lender", sort: "asc" },
  { label: "LOAN ID", field: "loanid", sort: "asc" },
  { label: "MERCHANT", field: "merchant", sort: "asc" },
  { label: "REPAYMENT AMOUNT", field: "repayment_amount", sort: "asc" },
  { label: "REPAYMENT DATE", field: "repaymentdate", sort: "asc" },
  { label: "STATUS", field: "status", sort: "asc" },
  { label: "STATUS TEXT", field: "status_text", sort: "asc" },
  { label: "TENURE", field: "tenure", sort: "asc" },
  {
    label: "RECONCILIATION REFERENCE ID",
    field: "xReconcillation_Reference_id",
    sort: "asc",
  },
];

// 1. loan schedule columns
export const loanScheduleColumns = [
  { label: "Repayment Date", field: "pay_date", sort: "asc" },
  { label: "Repayment Amount", field: "repay_amount", sort: "asc" },
];

//pending loans for checker disbursement
export const pendingLoansColumn = [
  { label: "", field: "check", sort: "asc" },
  { label: "LOAN ID", field: "loan_id", sort: "asc" },
  { label: "AGGREGATOR NAME", field: "aggregator_name", sort: "asc" },
  { label: "BORROWER'S NAME", field: "borrower_name", sort: "asc" },
  // Loan Details
  { label: "BORROWER ID", field: "borrower_id", sort: "asc" },
  { label: "LOAN STATUS", field: "status", sort: "asc" },
  { label: "LOAN AMOUNT", field: "loan_amount", sort: "asc" },
  { label: "LOAN REPAYMENT", field: "loan_amount_repay", sort: "asc" },
  { label: "REPAYMENT BALANCE", field: "loan_amount_repay", sort: "asc" },
  { label: "LOAN INTEREST", field: "loan_interest", sort: "asc" },
  { label: "LOAN REF", field: "loan_ref", sort: "asc" },
  { label: "REPAYMENT BALANCE", field: "loan_repayment_balance", sort: "asc" },
  { label: "LOAN TENURE", field: "loan_tenure", sort: "asc" },
  { label: "MODIFIED DATE", field: "modified_date", sort: "asc" },
  { label: "FUNDER NAME", field: "funder_name", sort: "asc" },
  { label: "EFFECTIVE DATE", field: "loan_effective_date", sort: "asc" },
  { label: "CREATED DATE", field: "pub_date", sort: "asc" },
  { label: "PRODUCT NAME", field: "product_name", sort: "asc" },
  {
    label: "PRODUCT CATEGORY NAME",
    field: "product_category_name",
    sort: "asc",
  },
  { label: "Trust SCORE", field: "trust_score", sort: "asc" },
  {
    label: "CONSOLIDATED SCORE DECISION",
    field: "disbursement_decision",
    sort: "asc",
  },
  { label: "CRC SCORE", field: "crc_score", sort: "asc" },
  { label: "CRC STATUS", field: "crc_status", sort: "asc" },
  { label: "FIRST CENTRAL SCORE", field: "xds_score", sort: "asc" },
  { label: "FIRST CENTRAL STATUS", field: "xds_status", sort: "asc" },
  { label: "SUPERFLUID SCORE", field: "sf_score", sort: "asc" },
  { label: "SUPERFLUID STATUS", field: "sf_status", sort: "asc" },
  { label: "KYC SCORE", field: "kyc_score", sort: "asc" },
  { label: "KYC DOB", field: "request_dob", sort: "asc" },
  { label: "REQUEST FIRST NAME", field: "request_firstname", sort: "asc" },
  { label: "REQUEST LAST NAME", field: "request_lastname", sort: "asc" },
  { label: "REQUEST PHONE NUMBER", field: "request_phone", sort: "asc" },
  { label: "REQUEST GENDER", field: "request_gender", sort: "asc" },
  //debit account details
  { label: "Debited Account Number", field: "debited_account_no", sort: "asc" },
  { label: "Debited Account Name", field: "debited_account_name", sort: "asc" },
  { label: "Debited Bank name", field: "debited_bank_name", sort: "asc" },
  { label: "Debited Bank Code", field: "debited_bank_code", sort: "asc" },
  //credit account details
  {
    label: "Credited Account Number",
    field: "credited_account_no",
    sort: "asc",
  },
  {
    label: "Credited Account Name",
    field: "credited_account_name",
    sort: "asc",
  },
  { label: "Credited Bank Name", field: "credited_bank_name", sort: "asc" },
  { label: "Credited Bank Code", field: "credited_bank_code", sort: "asc" },

  { label: "MANAGE", field: "manage" },
];

//failed loans disbursements
export const failedLoansColumn = [
  { label: "LOAN ID", field: "loan_id", sort: "asc" },
  { label: "BORROWER ID", field: "borrower_id", sort: "asc" },
  { label: "AGGREGATOR NAME", field: "biz_name", sort: "asc" },
  { label: "FIRST Name", field: "first_name", sort: "asc" },
  { label: "LAST Name", field: "last_name", sort: "asc" },
  { label: "STATUS", field: "is_active", sort: "asc" },
  { label: "LOAN AMOUNT", field: "loan_amount", sort: "asc" },
  { label: "LOAN REPAYMENT", field: "loan_amount_repay", sort: "asc" },
  { label: "REPAYMENT Balance", field: "loan_amount_repay", sort: "asc" },
  { label: "LOAN INTEREST", field: "loan_interest_amount", sort: "asc" },
  { label: "LOAN REF", field: "loan_ref", sort: "asc" },
  { label: "REPAYMENT BALANCE", field: "loan_repayment_balance", sort: "asc" },
  { label: "LOAN TENURE", field: "loan_tenure", sort: "asc" },
  { label: "MODIFIED DATE", field: "modified_date", sort: "asc" },
  { label: "CREATED DATE", field: "pub_date", sort: "asc" },
  //Product
  { label: "PRODUCT Name", field: "product_name", sort: "asc" },
  //debit account details
  {
    label: "Debited Account Number",
    field: "debit_account_number",
    sort: "asc",
  },
  {
    label: "Debited Account Name",
    field: "debit_bank_account_name",
    sort: "asc",
  },
  { label: "Debited Bank name", field: "debit_bank_name", sort: "asc" },
  { label: "Debited Bank Code", field: "debit_bank_code", sort: "asc" },
  //credit account details
  {
    label: "Credited Account Number",
    field: "credit_account_number",
    sort: "asc",
  },
  {
    label: "Credited Account Name",
    field: "credit_bank_account_name",
    sort: "asc",
  },
  { label: "Credited Bank Name", field: "credit_bank_name", sort: "asc" },
  { label: "Credited Bank Code", field: "credit_bank_code", sort: "asc" },
  // Gateway info
  {
    label: "Gateway Reference Number",
    field: "disbursement_gateway_reference_no",
    sort: "asc",
  },
  {
    label: "Gateway Response",
    field: "disbursement_gateway_response",
    sort: "asc",
  },
  {
    label: "Gateway Request",
    field: "disbursement_gateway_request",
    sort: "asc",
  },
  { label: "Status ID", field: "disbursement_gateway_status_id", sort: "asc" },
  {
    label: "Disbursement Channel Id",
    field: "disbursement_channel_id",
    sort: "asc",
  },
  {
    label: "Reference Number",
    field: "disbursement_reference_no",
    sort: "asc",
  },
  {
    label: "Disbursement final",
    field: "disbursement_gateway_final",
    sort: "asc",
  },
  {
    label: "Response Date-Time",
    field: "disbursement_response_date_time",
    sort: "asc",
  },
  {
    label: "Request Date-Time",
    field: "disbursement_request_date_time",
    sort: "asc",
  },

  { label: "MANAGE", field: "manage" },
];

// 1. loan schedule columns
export const disbursedAccountColumns = [
  { label: "S/N", field: "id", sort: "asc" },
  { label: "Channel Name", field: "channel_name", sort: "asc" },
  { label: "Bank Name", field: "bank_name", sort: "asc" },
  { label: "Account Name", field: "account_name", sort: "asc" },
  { label: "Account Number", field: "account_number", sort: "asc" },
  { label: "Currency", field: "currency", sort: "asc" },
  { label: "Wallet ID", field: "wallet_id", sort: "asc" },
  { label: "Wallet Provider", field: "wallet_provider", sort: "asc" },
];
export const RepaymentAccountColumns = [
  { label: "S/N", field: "id", sort: "asc" },
  { label: "Channel Name", field: "channel_name", sort: "asc" },
  { label: "Bank Name", field: "bank_name", sort: "asc" },
  { label: "Account Name", field: "account_name", sort: "asc" },
  { label: "Account Number", field: "account_number", sort: "asc" },
];
export const LiquidationAccountColumns = [
  { label: "S/N", field: "id", sort: "asc" },
  // { label: "Channel Name", field: "channel_name", sort: "asc" },
  // { label: "Bank Name", field: "bank_name", sort: "asc" },
  { label: "Account Name", field: "account_name", sort: "asc" },
  { label: "Account Number", field: "account_number", sort: "asc" },
];

//  Reorder an Array/Rows of records from the API
//  @dataTable {Object}
export const reOrderTableData = (columns, records) => {
  let newRows = [];

  if (records) {
    if (records.length > 0) {
      newRows = records.map((row) => {
        let newRow = {};
        columns.forEach((column) => {
          if (column.field === "pub_date") {
            newRow[column.field] = row[column.field].substring(0, 10);
            return;
          } else {
            newRow[column.field] = row.hasOwnProperty(column.field)
              ? column.field === "dueDate" ||
                column.field === "obligationsMetOnDate"
                ? formatMifosDate(row[column.field])
                : row[column.field]
              : null;
          }
        });
        return newRow;
      });
    } else {
      newRows = [];
    }
  }
  return {
    columns,
    rows: newRows,
  };
};

//  Reorder an Array/responseDataRecords of records from the API
export const reOrderBulkRows = (tableColumns, responseDataRecords) => {
  let newRows = [];

  if (responseDataRecords) {
    if (responseDataRecords.length > 0) {
      newRows = responseDataRecords.map((row, index) => {
        let newRow = {};
        tableColumns.forEach((column) => {
          newRow[column.field] = row[column.field] ? row[column.field] : null;
        });
        return newRow;
      });
    } else {
      newRows = [];
    }
  }

  return {
    columns: tableColumns,
    rows: newRows,
  };
};

//  Reorder an Array/Rows of records from the API
//  @dataTable {Object}
export const reOrderRows = (columns, records) => {
  let newRecords = [];

  if (records) {
    if (records.length > 0) {
      newRecords = records.map((record, index) => {
        let agg_details, borrower_details, okra_details;
        let agg_details_keys, borrower_details_keys, okra_details_keys;

        //step 2
        // if(record.aggregator_bank_details){

        //     agg_bk_details = { ...record.aggregator_bank_details };
        //     agg_bk_details_keys = Object.keys(agg_bk_details);
        // }
        // end

        if (record.okra_details) {
          okra_details = { ...record.okra_details[0] };
          okra_details_keys = Object.keys(okra_details);
        } else {
          okra_details_keys = [];
        }

        if (record.aggregator_details) {
          agg_details = { ...record.aggregator_details };
          agg_details_keys = Object.keys(agg_details);
        } else {
          agg_details_keys = [];
        }

        if (record.borrower_details) {
          borrower_details = { ...record.borrower_details };
          borrower_details_keys = Object.keys(borrower_details);
        } else {
          borrower_details_keys = [];
        }

        let newRecord = {};

        columns.forEach((column) => {
          if (record.hasOwnProperty(column.field)) {
            if (column.field === "pub_date") {
              newRecord[column.field] = record[column.field].substring(0, 10);
            } else {
              newRecord[column.field] = record[column.field];
            }
          } else if (column.field === "check") {
            newRecord[column.field] = null;
            return;
          } else {
            // step 3
            // if(agg_bk_details_keys.includes(column.field)){
            //     newRecord[column.field] = agg_bk_details[column.field];
            // }
            // end
            if (agg_details_keys.includes(column.field)) {
              newRecord[column.field] = agg_details[column.field];
            } else if (borrower_details_keys.includes(column.field)) {
              newRecord[column.field] = borrower_details[column.field];
            } else {
              newRecord[column.field] = "";
            }
          }
        });
        return newRecord;
      });
    } else {
      newRecords = [];
    }
  }

  return {
    columns,
    rows: newRecords,
  };
};

export const reOrderLoanRows = (columns, records) => {
  let newRecords = [];

  if (records) {
    if (records.length > 0) {
      newRecords = records.map((record, index) => {
        let agg_details, borrower_details, product_detail, okra_details;
        let agg_details_keys,
          borrower_details_keys,
          product_detail_keys,
          okra_details_keys;

        // if(record.aggregator_bank_details){

        //     agg_bk_details = { ...record.aggregator_bank_details };
        //     agg_bk_details_keys = Object.keys(agg_bk_details);
        // }

        if (record.okra_details) {
          okra_details = { ...record.okra_details[0] };
          okra_details_keys = Object.keys(okra_details);
        }

        if (record.aggregator_details) {
          agg_details = { ...record.aggregator_details };
          agg_details_keys = Object.keys(agg_details);
        }

        if (record.borrower_details) {
          borrower_details = { ...record.borrower_details };
          borrower_details_keys = Object.keys(borrower_details);
        }
        if (record.product_detail) {
          product_detail = { ...record.product_detail };
          product_detail_keys = Object.keys(product_detail);
        }

        let newRecord = {};

        columns.forEach((column) => {
          if (record.hasOwnProperty(column.field)) {
            newRecord[column.field] = record[column.field];
          } else if (column.field === "check") {
            newRecord[column.field] = null;
            return;
          } else {
            // if(agg_bk_details_keys.includes(column.field)){
            //     newRecord[column.field] = agg_bk_details[column.field];
            // }

            if (agg_details_keys.includes(column.field)) {
              newRecord[column.field] = agg_details[column.field];
            } else if (borrower_details_keys.includes(column.field)) {
              newRecord[column.field] = borrower_details[column.field];
            } else if (product_detail_keys.includes(column.field)) {
              newRecord[column.field] = product_detail[column.field];
            } else {
              newRecord[column.field] = "n/a";
            }
          }
        });
        return newRecord;
      });
    } else {
      newRecords = [];
    }
  }

  return {
    columns,
    rows: newRecords,
  };
};
//  Reorder an Array/Rows of loan repayment records from the API
export const reOrderRepaymentRows = (tableColumns, responseDataRecords) => {
  let newRows = [];

  if (responseDataRecords) {
    if (responseDataRecords.length > 0) {
      newRows = responseDataRecords.map((row, index) => {
        let newRow = {};
        tableColumns.forEach((column) => {
          if (column.field === "id") {
            newRow[column.field] = index + 1;
            return;
          } else if (column.field === "pub_date") {
            newRow[column.field] = row[column.field].substring(0, 10);
            return;
          } else if (column.field === "loan_due_date") {
            newRow[column.field] = row[column.field].substring(0, 10);
            return;
          }
          newRow[column.field] = row[column.field] ? row[column.field] : null;
        });
        return newRow;
      });
    } else {
      newRows = [];
    }
  }

  return {
    columns: tableColumns,
    rows: newRows,
  };
};

// reorder failed disbursement
export const reOrderFailedDisbursementRows = (columns, records) => {
  let newRecords = [];

  if (records) {
    if (records.length > 0) {
      newRecords = records.map((record, index) => {
        let agg_details,
          borrower_details,
          okra_details,
          credit_bank_details,
          debit_bank_details;
        let agg_details_keys,
          borrower_details_keys,
          okra_details_keys,
          credit_bank_details_keys,
          debit_bank_details_keys;

        //step 2
        // if(record.aggregator_bank_details){

        //     agg_bk_details = { ...record.aggregator_bank_details };
        //     agg_bk_details_keys = Object.keys(agg_bk_details);
        // }
        // end

        if (record.okra_details) {
          okra_details = { ...record.okra_details[0] };
          okra_details_keys = Object.keys(okra_details);
        }

        if (record.aggregator_details) {
          agg_details = { ...record.aggregator_details };
          agg_details_keys = Object.keys(agg_details);
        }

        if (record.borrower_details) {
          borrower_details = { ...record.borrower_details };
          borrower_details_keys = Object.keys(borrower_details);
        }
        if (record.credit_bank_details) {
          credit_bank_details = { ...record.credit_bank_details };
          credit_bank_details_keys = Object.keys(credit_bank_details);
        }

        if (record.debit_bank_details) {
          debit_bank_details = { ...record.debit_bank_details };
          debit_bank_details_keys = Object.keys(debit_bank_details);
        }
        let newRecord = {};

        columns.forEach((column) => {
          if (record.hasOwnProperty(column.field)) {
            if (column.field === "pub_date") {
              newRecord[column.field] = record[column.field].substring(0, 10);
            } else {
              newRecord[column.field] = record[column.field];
            }
          } else if (column.field === "check") {
            newRecord[column.field] = null;
            return;
          } else {
            // step 3
            // if(agg_bk_details_keys.includes(column.field)){
            //     newRecord[column.field] = agg_bk_details[column.field];
            // }
            // end
            if (agg_details_keys.includes(column.field)) {
              newRecord[column.field] = agg_details[column.field];
            } else if (borrower_details_keys.includes(column.field)) {
              newRecord[column.field] = borrower_details[column.field];
            } else if (credit_bank_details_keys?.includes(column.field)) {
              newRecord[column.field] = credit_bank_details[column.field];
            } else if (debit_bank_details_keys?.includes(column.field)) {
              newRecord[column.field] = debit_bank_details[column.field];
            } else {
              return;
            }
          }
        });
        return newRecord;
      });
    } else {
      newRecords = [];
    }
  }

  return {
    columns,
    rows: newRecords,
  };
};
